module.exports = __webpack_public_path__ + "static/aws_certified-10d6d6ae385fcd62001e39a0aa7d33c3.png";